import { oc } from "ts-optchain";

import { DealernetApi } from "./DealernetApi";

var settings: Array<object> = [];

export class SettingsService {
  public static async getAllSettings(): Promise<any> {
    //Store and return this value (similar to feature flags)
    if(settings.length > 0){
      return settings;
    }
    const response = await DealernetApi.client().request({
        method: "get",
        url: `settings/get-all-settings`
    });

    settings = oc(response).data([]);
    return settings;
  }
}
